import { styled } from '@stitches/configed';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { CSSProperties } from 'react';

const VerifiedStatusStyled = styled('span', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '$danger',
  variants: {
    verified: {
      true: {
        color: '$positive',
      },
    },
  },
});
type Props = {
  verified: boolean;
  verifiedText?: string;
  unverifiedText?: string;
  style?: CSSProperties;
};
export const VerifiedStatus = ({
  verified,
  verifiedText,
  unverifiedText,
  style,
}: Props) => {
  return (
    <VerifiedStatusStyled verified={verified} style={style}>
      <Tooltip
        title={
          verified
            ? verifiedText
              ? verifiedText
              : 'Đã xác thực'
            : unverifiedText
            ? unverifiedText
            : 'Chưa xác thực'
        }
      >
        {verified ? <CheckCircleFilled /> : <CloseCircleFilled />}
      </Tooltip>
    </VerifiedStatusStyled>
  );
};
